import React from 'react';
import styled from 'styled-components/macro';
import { comboLogo } from '../../assets';
import { NavLink } from 'react-router-dom';

const HomeLogoImage = styled(NavLink)`
  img {
    width: 150px;

    @media print {
      height: 50px;
    }
  }

  @media print {
    position: absolute;
    margin: 0 0 0 0;
    left: unset;
    right: 0;
  }
`;

const YSaatioLogo = () => (
  <HomeLogoImage exact to="/irtisano">
    <img src={comboLogo} alt="Y-Säätiö logo" aria-label="Siirry kotisivulle" />
  </HomeLogoImage>
);
export default YSaatioLogo;
